var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:(_vm.options),expression:"options"}],staticClass:"gallery"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }